import {createContext, useContext, useEffect, useReducer} from 'react';
import {getAPIHost} from "../api-helper";
const PromptusAPIContext = createContext(null);
const PromptusAPIDispatchContext = createContext(null);

export function PromptusAPIProvider ({children}) {
    const [apiState, dispatch] = useReducer(promptusAPIReducer, {online: true, host: "", models: [], loras: [], activeGPU: false, activeCPU: false, activeCosy: false});
    useEffect(() => {
        getAPIHost(apiState, dispatch);
    }, [apiState.online]);
    return (
        <PromptusAPIContext.Provider value={apiState}>
            <PromptusAPIDispatchContext.Provider value={dispatch}>
                {children}
            </PromptusAPIDispatchContext.Provider>
        </PromptusAPIContext.Provider>
    );
}

function promptusAPIReducer(apiState, action) {
    console.log('API Context', apiState, action);
    switch (action.type) {
        case 'offline': {
            console.log('Promptus offline');
            return {...apiState, online: false};
        }
        case 'online': {
            console.log('Promptus online');
            return {...apiState, online: true};
        }
        case 'setHost': {
            console.log('Promptus host', action.host);
            return {...apiState, host: action.host};
        }
        case 'setModels': {
            console.log('API Models', action.models);
            return {...apiState, models: action.models};
        }
        case 'setLoras': {
            console.log('API Loras', action.loras);
            return {...apiState, loras: action.loras};
        }
        case 'setActiveGPU': {
            return {...apiState, activeGPU: action.server, activeCPU: false, activeCosy: false};
        }
        case 'setActiveCPU': {
            return {...apiState, activeCPU: action.server, activeGPU: false, activeCosy: false};
        }
        case 'setActiveCosy': {
            return {...apiState, activeCosy: action.server, activeGPU: false, activeCPU: false};
        }
        default:
            return apiState;
    }
}

export function usePromptusAPIState() {
    return useContext(PromptusAPIContext);
}

export function usePromptusAPIDispatch() {
    return useContext(PromptusAPIDispatchContext);
}
